import React from 'react';
import "../Figure.css"


function Figure16() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th></th>
              <th> Cd concentration after incubation (30min)</th>
              <th> Cd uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 0.195 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20(1) </th>
              <td> 0.065 mg/L </td>
              <td> 0.13 mg/L </td>
            </tr> 
            <tr>
              <th> SpaC(1) </th>
              <td> 0.064 mg/L </td>
              <td> 0.131 mg/L </td>
            </tr>
            <tr>
              <th> EC20(2) </th>
              <td> 0.072 mg/L </td>
              <td> 0.123 mg/L </td>
            </tr>  
            <tr>
              <th> SpaC(2) </th>
              <td> 0.052 mg/L </td>
              <td> 0.143 mg/L </td>
            </tr> 
          </tbody>
        </table>
    </div>
  );
}

export default Figure16;